var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',{staticClass:"text-center mt-3"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" Dashboard | Favicon z "),_c('a',{attrs:{"href":"https://www.flaticon.com/authors/pixel-perfect"}},[_vm._v("Flaticon.com")])])])}
var staticRenderFns = []

export { render, staticRenderFns }